export default{
  light:[],
  dark:[],
  mode:[
    {value:'light', label:'Claro'},
    {value:'dark', label:'Escuro'},
    {value:'system', label:'Automático'}
  ]
}
